var _rect, _line, _line2, _circle, _circle2, _circle3, _path, _path2, _path3, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#190A4E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 50,
    x2: 250,
    y2: 450,
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 250,
    x2: 450,
    y2: 250,
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 150,
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.1,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 100,
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.1,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 120,
    fill: "none",
    stroke: "#FFB02E",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 160 L320 250 L250 340 L180 250 Z",
    fill: "#00D9FF",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 160 L280 200 L220 200 Z",
    fill: "#FFB02E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250 340 L280 300 L220 300 Z",
    fill: "#FFB02E"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 130,
    y2: 100,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 100,
    y2: 130,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 100,
    x2: 370,
    y2: 100,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 100,
    x2: 400,
    y2: 130,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 400,
    x2: 130,
    y2: 400,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 400,
    x2: 100,
    y2: 370,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 400,
    x2: 370,
    y2: 400,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 400,
    x2: 400,
    y2: 370,
    stroke: "#00D9FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 470,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle",
    opacity: 0.7
  }, "LOGO DESIGN")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDesign);
export default __webpack_public_path__ + "static/media/logo-design.ec1e2ebc894c5ce65c1da5a259e424e4.svg";
export { ForwardRef as ReactComponent };